export default "__VITE_ASSET__ab12nE9___"